// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  userId: __t.u64().primaryKey().name("user_id"),
  tileTheme: __t.option(__t.u64()).name("tile_theme"),
  numberColors: __t.option(__t.u64()).name("number_colors"),
  boardBorder: __t.option(__t.u64()).name("board_border"),
  flagSkin: __t.option(__t.u64()).name("flag_skin"),
  mineSkin: __t.option(__t.u64()).name("mine_skin"),
  cursorSkin: __t.option(__t.u64()).name("cursor_skin"),
  winAnimation: __t.option(__t.u64()).name("win_animation"),
  lossAnimation: __t.option(__t.u64()).name("loss_animation"),
  explosionEffect: __t.option(__t.u64()).name("explosion_effect"),
  soundPack: __t.option(__t.u64()).name("sound_pack"),
  desktopWallpaper: __t.option(__t.u64()).name("desktop_wallpaper"),
  windowTheme: __t.option(__t.u64()).name("window_theme"),
  profileFrame: __t.option(__t.u64()).name("profile_frame"),
  profileBackground: __t.option(__t.u64()).name("profile_background"),
  titleBadge: __t.option(__t.u64()).name("title_badge"),
  smileySkin: __t.option(__t.u64()).name("smiley_skin"),
});
